import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToId } from "../../lib/smooth";

const LINKS = [
  ["craft", "The Can"],
  ["origin", "The Spark"],
  ["founder", "Founder"],
  ["journey", "Journey"],
  ["ciders", "Ciders"],
  ["proof", "Footprint"],
  ["find-us", "Find us"],
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 40);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  const go = (id) => { setOpen(false); scrollToId(id); };

  return (
    <>
      <header
        data-testid="site-nav"
        className={`fixed inset-x-0 top-0 z-50 transition-[background-color,backdrop-filter,border-color] duration-500 ${scrolled ? "border-b border-forest/15 bg-white/90 backdrop-blur-xl" : "border-b border-transparent"}`}
      >
        <div className="wrap flex h-[72px] items-center justify-between">
          <button data-testid="nav-logo" onClick={() => go("top")} aria-label="Back to top"><Logo /></button>
          <nav className="hidden items-center gap-8 lg:flex">
            {LINKS.map(([id, label]) => (
              <button key={id} data-testid={`nav-link-${id}`} onClick={() => go(id)} className="group relative font-body text-[13px] uppercase tracking-[0.2em] text-forest-deep transition-colors hover:text-forest">
                {label}
                <span className="absolute -bottom-1 left-0 h-px w-full origin-left scale-x-0 bg-forest transition-transform duration-500 group-hover:scale-x-100" />
              </button>
            ))}
          </nav>
          <div className="flex items-center gap-3">
            <button data-testid="nav-enquire-btn" onClick={() => go("contact")} className="hidden rounded-full border border-forest px-5 py-2.5 font-body text-[12px] uppercase tracking-[0.2em] text-forest transition-colors hover:bg-forest hover:text-white sm:inline-flex">
              Trade enquiry
            </button>
            <button data-testid="nav-menu-btn" onClick={() => setOpen(true)} className="grid h-11 w-11 place-items-center rounded-full border border-forest-deep/30 text-forest-deep lg:hidden" aria-label="Open menu">
              <Menu className="h-5 w-5" />
            </button>
          </div>
        </div>
      </header>
      {open && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="fixed inset-0 z-[60] flex flex-col bg-white px-6 py-5 text-forest-deep" data-testid="mobile-menu">
          <div className="flex items-center justify-between">
            <Logo />
            <button data-testid="mobile-menu-close" onClick={() => setOpen(false)} className="grid h-11 w-11 place-items-center rounded-full border border-forest-deep/30" aria-label="Close menu"><X className="h-5 w-5" /></button>
          </div>
          <div className="mt-14 flex flex-col gap-2">
            {[...LINKS, ["contact", "Contact"]].map(([id, label], i) => (
              <motion.button key={id} data-testid={`mobile-link-${id}`} onClick={() => go(id)} initial={{ opacity: 0, x: -20 }} animate={{ opacity: 1, x: 0 }} transition={{ delay: 0.05 * i }} className="border-b border-forest-deep/10 py-4 text-left font-display text-4xl font-semibold">
                <span className="mr-4 font-mono text-xs text-forest">0{i + 1}</span>{label}
              </motion.button>
            ))}
          </div>
        </motion.div>
      )}
    </>
  );
}
